import { Skeleton } from '@mui/material'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
export const LeaderboardSkeleton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.leaderboard

  const leadersStyles = [138, 159, 123]

  return (
    <div className={classes.root}>
      <div style={{ width: '100%', height: '201px' }}>
        <div
          className={classes.totalAccountValueWrapper}
          style={{ position: 'relative', height: '200px' }}
        >
          <span className={classes.totalAccountValueText}>{texts.total_value}</span>
          <Skeleton
            variant="rounded"
            width={200}
            height={44}
            style={{ marginTop: '8px' }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          marginTop: '24px',
          padding: '0px 12px',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
        }}
      >
        {leadersStyles.map((height) => (
          <Skeleton
            variant="rounded"
            width={110}
            height={height}
            style={{ borderRadius: '20px 20px 0 0' }}
          />
        ))}
      </div>
      <div style={{ padding: '12px', width: '100%' }}>
        <Skeleton
          width={'100%'}
          height={32}
          style={{ minHeight: '32px' }}
        />
      </div>
      <div
        className={classes.header}
        style={{ marginTop: '12px' }}
      >
        <div className={classes.placeTittle}>#</div>
        <div className={classes.nameTittle}>{texts.name}</div>
        <div className={classes.variant}>{texts.units['gigi']}</div>
      </div>
      <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '12px', padding: '12px' }}>
        {Array.from({ length: 8 }).map(() => (
          <Skeleton
            variant="rounded"
            width={'100%'}
            height={58}
            style={{ borderRadius: '12px' }}
          />
        ))}
      </div>
    </div>
  )
}
